<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <el-form :model="form">
    <el-tabs type="border-card" class="page-content tabs-content">
      <el-tab-pane label="站点设置">

<!--          <el-form-item label="站点名称" :label-width="formLabelWidth">
            <el-input v-model="form.site_name"></el-input>
          </el-form-item>-->
          <el-form-item label="网站标题" :label-width="formLabelWidth">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="网站关键词" :label-width="formLabelWidth">
            <el-input v-model="form.meta_keywords"></el-input>
          </el-form-item>
          <el-form-item label="网站描述" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="form.meta_description"></el-input>
          </el-form-item>
          <el-divider content-position="left">底部信息</el-divider>
          <el-form-item label="版权信息" :label-width="formLabelWidth">
            <el-input v-model="form.copyright"></el-input>
          </el-form-item>
          <el-form-item label="QQ" :label-width="formLabelWidth">
            <el-input v-model="form.qq"></el-input>
          </el-form-item>
          <el-form-item label="微信二维码" :label-width="formLabelWidth">

          </el-form-item>
          <el-form-item label="微博" :label-width="formLabelWidth">
            <el-input v-model="form.weibo"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" :label-width="formLabelWidth">
            <el-input v-model="form.tel"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" :label-width="formLabelWidth">
            <el-input v-model="form.address"></el-input>
          </el-form-item>


      </el-tab-pane>
      <el-tab-pane label="绑定域名" name="second">
        <el-form-item :label="'域名'+(index+1)" prop="domain" v-for="(item,index) in domainList" :key="index" v-if="domainList.length > 0">
          <el-input v-model="domainList[index].domain"></el-input><span>不含http://，不含https://</span>
        </el-form-item>
        <div class="btn-add"><el-button @click="clickAdd"><i class="el-icon-circle-plus-outline"></i>添加</el-button></div>
      </el-tab-pane>
      <el-form-item  :label-width="formLabelWidth">
        <el-button type="primary" @click="onSubmit">立即保存</el-button>
      </el-form-item>
    </el-tabs>
    </el-form>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import MyHeader from '../header'
  export default {
    name: 'setting',
    components: {MyHeader},
    data(){
      return {
        breadcrumb:[
          {name:'系统设置'},{name:'站点设置'}
        ],
        form:{},
        formLabelWidth:'120px',
        domainList:[]
      }
    },
    created () {
      var _this = this;
      this.$http.get('/v1/shop-config/view',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
        if (data.errcode == 0){
          this.form = data.result;
        }
      })
      this.$http.get('/v1/site-domain/list',{params:{site_id:Cookies.get('siteId')}}).then((res)=>{
        if (res.data.errcode == 0){
          _this.domainList = res.data.result
        }
      });
    },
    methods:{
      onSubmit(){

        this.$http.post('/v1/shop-config/save',{shopConfig:this.form,site_id:Cookies.get('siteId'),domainList:this.domainList}).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg)
          }
        })
      },
      clickAdd(){
        if (this.domainList.length != 0){
          if (this.domainList.length < 2){
            this.domainList.push({
              domain:''
            })
            if (this.domainList.length > 2){
              this.$message.error('最多可以添加2个')
            }
          }else{
            this.$message.error('最多可以添加2个')
          }
        }else {
          this.domainList.push({
            domain:''
          })
        }
      }
    }
  }
</script>

<style scoped>
  .tabs-content{
    padding:0;
  }
</style>
